<template>
  <section id="conversation">
    <b-breadcrumb
      :items="breadcrumb"
    />

    <b-row>
      <b-col cols="12">
        <b-card-actions
          ref="cardActions"
          title="Spider Jobs"
          class="form-filters"
          :action-close="false"
          :action-refresh="true"
          :action-collapse="false"
          @refresh="getJobs"
        >
          <b-row
            class="header-card"
            align-v="center"
          >
            <b-col
              class="text-right"
            >
              <b-button
                text="Ações com usuários marcados"
                variant="primary"
                @click="newJob"
              >
                <span>Criar novo Job</span>
              </b-button>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-table
                :busy="isLoading"
                responsive
                :items="results"
                :fields="result_fields"
                show-empty
                sort-icon-left
                no-local-sorting
                :sort-by.sync="filtersValues.sortBy"
                :sort-desc.sync="filtersValues.sortDesc"
                @sort-changed="sortingChanged"
              >
                <template #empty>
                  <h4 class="text-center mt-2 mb-2">
                    Nenhum resultado encontrado
                  </h4>
                </template>

                <template #table-busy>
                  <div class="text-center table-spinner">
                    <b-spinner label="Loading..." />
                    <strong>Carregando...</strong>
                  </div>
                </template>

                <template #cell(execution)="row">
                  <div>
                    <span>Período de execução: {{ row.item.run_period_number }}{{ row.item.run_period_digit }}</span><br />
                    <span>Delay após match: {{ row.item.delay_period_number }}{{ row.item.delay_period_digit }}</span><br />
                    <span v-if="row.item.last_run_at">Última Execução: {{ row.item.last_run_at | date }}</span>
                    <span v-if="!row.item.last_run_at">Última Execução: nunca</span>
                  </div>
                </template>

                <template #cell(select)="row">
                  <b-form-checkbox
                    v-model="selectedUserIds"
                    name="selectedUsers"
                    :value="row.item.id"
                  />
                </template>

                <template #cell(types)="row">
                  <div class="d-flex flex-column">
                    <span v-if="row.item.message_whats && row.item.message_whats">WhatsApp</span>
                    <span v-if="row.item.message_email && row.item.message_email">E-mail</span>
                  </div>
                </template>

                <template #cell(active)="row">
                  <b-form-checkbox
                    :checked="row.item.active"
                    :disabled="true"
                    switch
                  >
                  </b-form-checkbox>
                </template>

                <template #cell(actions)="row">
                  <div class="text-nowrap text-center">
                    <b-button
                      v-if="$can('read', 'Users')"
                      variant="flat-primary"
                      :to="{ name: 'cms-tools-spider-test', params: { id: row.item.id } }"
                      title="Testar"
                    >
                      <feather-icon
                        icon="EyeIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </b-button>

                    <b-button
                      v-if="$can('read', 'Users')"
                      variant="flat-primary"
                      :to="{ name: 'cms-tools-spider-edit', params: { id: row.item.id } }"
                      title="Editar"
                    >
                      <feather-icon
                        icon="EditIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </b-button>

                    <b-button
                      v-if="$can('read', 'Users')"
                      variant="flat-primary"
                      title="Remover"
                      @click="removeJob(row.item.id)"
                    >
                      <feather-icon
                        icon="TrashIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </b-button>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
              <p>Mostrando {{ pages.from }} até {{ pages.to }} de {{ pages.total }} resultados</p>
            </b-col>

            <b-col cols="6">
              <!-- pagination nav -->
              <b-pagination-nav
                v-model="currentPage"
                :number-of-pages="pages.last_page"
                base-url="#"
                align="end"
              />
            </b-col>
          </b-row>
        </b-card-actions>
      </b-col>
    </b-row>

  </section>
</template>

<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import UserService from '@/services/userService'
import SpiderJobService from '@/services/spiderJobService'
import toast from '@/mixins/toast'
import { formatDateTimeDbToView } from '@/utils/helpers'
import {
  BRow,
  BCol,
  BTable,
  BFormCheckbox,
  BPaginationNav,
  BSpinner,
  BButton,
  BBreadcrumb,
} from 'bootstrap-vue'

export default {
  components: {
    BCardActions,
    BRow,
    BCol,
    BTable,
    BFormCheckbox,
    BPaginationNav,
    BSpinner,
    BButton,
    BBreadcrumb,
  },
  mixins: [toast],
  data() {
    return {
      userService: null,
      isLoading: false,
      isSubmited: false,
      cardData: {},
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'cms-dashboard' },
        },
        {
          text: 'Ferramentas - Spider Jobs',
          active: true,
        },
      ],

      filtersInitialValues: {},
      filtersValues: {
        emails: '',
        type: 'all',
        status: 'all',
        sortBy: 'id',
        sortDesc: true,
      },

      pages: 1,
      currentPage: 1,
      results: [],
      result_fields: [],
      formatDateTimeDbToView,
      preventCloseModal: false,
      dataAssignKanban: null,
      dataKanbanAdditional: null,
    }
  },
  computed: {
    variant() {
      return document.body.classList.contains('dark-layout') ? 'dark' : undefined
    },
  },

  watch: {
    currentPage() {
      this.getJobs()
    },
  },

  created() {
    this.userService = new UserService()
    this.filtersInitialValues = { ...this.filtersValues }

    this.result_fields = [
      { key: 'name', label: 'Nome', sortable: true },
      { key: 'priority', label: 'Prioridade', sortable: true },
      { key: 'execution', label: 'Execução', sortable: false },
      { key: 'types', label: 'Tipos', sortable: false },
      { key: 'active', label: 'Ativo', sortable: false },
      { key: 'actions', sortable: false, thStyle: 'width: 180px' },
    ]

    this.getJobs()
  },

  methods: {
    handleCtrlEnter(e) {
      if (e.ctrlKey) {
        this.getJobs()
      }
    },

    removeJob(id) {
      this.$swal({
        title: 'Deletar job?',
        text: 'Esta ação não poderá ser desfeita!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, deletar!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isRemoving = true
          this.$refs.cardActions.showLoading = true

          await SpiderJobService.deleteJob(id)
          this.results = this.results.filter(f => f.id !== id)
        }
      }).finally(() => {
        this.isRemoving = false
        this.$refs.cardActions.showLoading = false
      })
    },

    getJobs() {
      this.isLoading = true
      this.filtersValues.page = this.currentPage
      SpiderJobService.list(this.filtersValues).then(response => {
        this.results = response.data.data.jobs.data
        this.pages = {
          ...response.data.data.jobs,
          data: null,
        }
      }).finally(() => {
        this.isLoading = false
        this.$refs.cardActions.showLoading = false
      })
    },

    newJob() {
      this.$router.push({ name: 'cms-tools-spider-edit', params: { id: 0 } })
    },

    reset() {
      this.filtersValues = JSON.parse(JSON.stringify(this.filtersInitialValues))
      this.results = []
      this.isSubmited = false
    },

    sortingChanged(ctx) {
      this.filtersValues.sortBy = ctx.sortBy
      this.filtersValues.sortDesc = ctx.sortDesc
      this.getJobs()
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .header-card{
    margin-bottom: 20px;
  }

  .form-buttons button{
    margin-right: 10px;
  }
</style>
